import createTsdApi from "../../../client-api/createTsdApi";
import {
  RemittanceCreditUse,
  RemittanceCreditUseCreateParams,
  RemittanceCreditUseQueryParams,
  RemittanceCreditUseUpdateParams,
} from "../../../entities/RemittanceCreditUse/remittanceCreditUse";
import { TsdSearchParam } from "../fetch";

const remittanceCreditUseApi = createTsdApi<
  RemittanceCreditUse,
  RemittanceCreditUseQueryParams,
  RemittanceCreditUseCreateParams,
  RemittanceCreditUseUpdateParams
>("remittance-credit-uses", (params) => {
  const search: TsdSearchParam<RemittanceCreditUseQueryParams>[] = [];

  ({
    ids: (() => {
      if (typeof params.ids !== "undefined") {
        params.ids.forEach((id) =>
          search.push({ key: "ids", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({
          key: "limit",
          value: String(params.limit),
        });
      }
    })(),
    remittanceIds: (() => {
      if (typeof params.remittanceIds !== "undefined") {
        params.remittanceIds.forEach((id) =>
          search.push({ key: "remittanceIds", value: String(id) })
        );
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({
          key: "offset",
          value: String(params.offset),
        });
      }
    })(),
  }) satisfies {
    [key in keyof Required<RemittanceCreditUseQueryParams>]: void | undefined;
  };

  return search;
});

export default {
  get: remittanceCreditUseApi.get,
  getOne: remittanceCreditUseApi.getOne,
};
